import { CMSPath } from "../config/constant"
import common_en from "../translations/en/en_translations.json";

export async function GetTranslationKeys(fetchLanguage) {

    let response = {}

    if (process.env.REACT_APP_DISABLE_DYNAMIC_TRANSLATION_KEYS === "true") {
        return;
    }

    try {

        const headerConfig = {
            headers: { Authorization: `Bearer ${localStorage.getItem("GuestJourneySessionToken")}` }
        };

        response = await fetch(`${CMSPath}/Connector/rest/assets?type=localisation&languageCode=${fetchLanguage}`, headerConfig)
        console.log("success getting translation keys")
        const langKeys = await response.json()

        response = ConfigTranslationskeys(langKeys , common_en)
        return response
    } catch (err) {
        console.log("Got error while getting translation keys" + JSON.stringify(err))

        response = ConfigTranslationskeys(response , common_en)
        return response
    }
}





export function ConfigTranslationskeys(target, source) {

    for (const key of Object.keys(source)) {

        if (key in target) {
            if (typeof target[key] === "object" && typeof source[key] === "object") {
                ConfigTranslationskeys(target[key], source[key]);
            }
        } else {
            target[key] = source[key];
        }

    }

    return target;
}